module.exports = __webpack_public_path__ + "img/running-old.ed213ad8.png";